import { Instance, types } from 'mobx-state-tree';

export const AttachmentPartnerModel = types.model({
  id: types.number,
  file: types.string,
  createdAt: types.string,
});

export const BecomePartnerModel = types.model({
  id: types.number,
  contactPersonName: types.string,
  companyName: types.string,
  phoneNumber: types.string,
  country: types.string,
  city: types.string,
  email: types.string,
  websiteUrl: types.string,
  createdAt: types.string,
  updatedAt: types.string,
  attachments: types.optional(types.array(AttachmentPartnerModel), []),
});

export type BecomePartner = Instance<typeof BecomePartnerModel>
